import mixins from 'synergycms_core/src/less/mixins';

export default {
  confirmationContainer:{
    background: '#f1f1f1',
    paddingBottom: '20px',
    boxSizing:'border-box',
    '@media (min-width: 801px), print': {
      padding: '0 20px 20px'
    }
  },
  confirmationBox:{
    position: 'relative',
    padding: '13px',
    ...mixins.boxShadow(' 0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
    background:'#fff',
    boxSizing:'border-box',
    '@media (min-width: 801px), print': {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '0',
    }
  },
  mBoxContainer:{
    textAlign:'center',
    margin:'0 auto',
  },
};